import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../../../components/Layout';
import { loginWithLinkedIn } from '../../../api/loginWithLinkedIn';
import { handleUserResponse } from 'lib/auth';
import { Spinner } from 'components/Elements';

export const LinkedInRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleLinkedInAuth = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');

      if (!code) {
        console.error('No LinkedIn code found in the URL.');
        navigate('/auth/login');
        return;
      }

      try {
        // Call the API with the LinkedIn code
        const response = await loginWithLinkedIn({ code });

        const user = await handleUserResponse(response);

        console.log('LinkedIn login successful:', user);

        navigate('/app'); // Redirect to the main app
      } catch (error) {
        console.error('Error during LinkedIn login:', error);
        navigate('/auth/login'); // Redirect to login page on error
      }
    };

    handleLinkedInAuth();
  }, [navigate]);

  return (
    <Layout title="Logging in with LinkedIn">
      <div className="flex justify-center items-center min-h-screen">
        <p className="text-md">Signing in with Linkedin. Please wait.</p>
        <Spinner />
      </div>
    </Layout>
  );
};
